/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_TRANSACTION: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.provisionalDetailPage.getTransactionList',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_TRANSACTION' },
      },
    },
    GET_TRANSACTION: {
      invoke: {
        id: 'getTransactionList',
        src: 'getTransactionList',
        onDone: {
          target: 'GET_TRANSACTION_LIST',
          actions: ['successAction'],
        },
        onError: {
          target: 'GET_TRANSACTION_LIST_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    GET_TRANSACTION_LIST: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_TRANSACTION',
        },
      },
    },
    GET_TRANSACTION_LIST_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
